import { ChangeEvent, useState } from "react";

import { Checkbox, LineClamp } from "@newsela/angelou";
import { withTrackEvent, objectTypes, actionNames } from "@newsela/snitch";

import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";
import { IStandard } from "@/search/NewSearchPageMVP/types/IStandard";
import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";
import { useStandardsSearchContext } from "@/search/NewSearchPageMVP/provider/StandardsSearchProvider";
import {
  listItemCss,
  checkboxCss,
  gradeTextCss,
  standardDescriptionCss,
} from "../../StandardsModal.styles";
import { getGradesText } from "./StandardsModalCheckbox.utils";

const CheckboxWithTrackEvent = withTrackEvent(Checkbox);

interface StandardsModalCheckboxProps {
  standard: IStandard;
}

export const StandardsModalCheckbox = ({
  standard,
}: StandardsModalCheckboxProps) => {
  const { updateSelectedStandardsOnChange } = useStandardsSearchContext();
  const {
    handlers: { hasSearchParamValue },
  } = useSearchPageContext();

  const standardTitle =
    `${standard.display_fields.number_enhanced}` +
    (standard.total_content_tagged
      ? ` (${standard.total_content_tagged})`
      : "");
  const grades = standard.display_fields.grades;
  const gradesText = getGradesText(grades);

  const [isChecked, setIsChecked] = useState<boolean>(
    hasSearchParamValue(
      AgathaSchemaParamsEnum.related_to_standards,
      standard.content_id,
    ),
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const standardParsed = JSON.parse(e.target.value);

    updateSelectedStandardsOnChange(e.target.checked, standardParsed);
    setIsChecked(e.target.checked);
  };

  return (
    <li css={listItemCss}>
      <CheckboxWithTrackEvent
        __cssFor={checkboxCss}
        label={standardTitle}
        value={JSON.stringify(standard)}
        checked={isChecked}
        onChange={handleChange}
        objectType={objectTypes.content}
        actionName={actionNames.filter}
        streamProperties={{ description: "Select standard for search query" }}
        dataProps={{
          "data-qa-selector": `search-standard-${JSON.stringify(standard)}`,
        }}
      />
      {grades.length ? <div css={gradeTextCss}>{gradesText}</div> : null}
      <LineClamp
        lines={1}
        text={standard.description || ""}
        innerElement="p"
        css={standardDescriptionCss}
      />
    </li>
  );
};
